<template>
  <div class="pagination">
    <button
      :class="['jump-page', { disabled: !showPrevious }]"
      :disabled="!showPrevious"
      @click="onPreviousPage"
    >
      <span>Prev</span>
    </button>
    <div class="pages">
      <button
        v-for="i in totalPages"
        :class="['page', { 'current-page': i === currentPage }]"
        :key="i"
        @click="onChangePage(i)"
      >
        {{ i }}
      </button>
    </div>
    <button
      :class="['jump-page', { disabled: !showNext }]"
      :disabled="!showNext"
      @click="onNextPage"
    >
      <span>Next</span>
    </button>
  </div>
</template>

<script>
  export default {
    name: "Pagination",
    props: {
      currentPage: {
        type: Number,
        required: true
      },
      rowsPerPage: {
        type: Number,
        required: true
      },
      totalRows: {
        type: Number,
        required: true
      }
    },
    computed: {
      totalPages() {
        return Math.ceil(this.totalRows / this.rowsPerPage);
      },
      showPrevious() {
        return this.currentPage > 1;
      },
      showNext() {
        return this.currentPage !== this.totalPages;
      }
    },
    methods: {
      onChangePage(page) {
        this.$emit("change-page", page);
      },
      onNextPage() {
        this.$emit("next-page");
      },
      onPreviousPage() {
        this.$emit("previous-page");
      }
    },
  };
</script>

<style scoped lang="scss">
  .pagination {
    display: flex;
    flex-wrap: no-wrap;
    align-items: center;
    justify-content: center;
    padding: 12px;
    background: $color-primary;

    .page,
    .jump-page {
      padding: 8px 12px;
      cursor: pointer;
      color: $color-white;
      font-weight: $font-semibold;
      border-radius: $radius;
      min-width: 0;
      background: transparent;

      &:hover,
      &.current-page {
        background: $color-secondary;
      }
    }

    .pages {
      flex-grow: 1;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: center;

      .page {
        margin: 1px;
      }
    }

    .jump-page {
      text-transform: uppercase;
      flex-shrink: 0;

      &.disabled {
        color: rgba(255,255,255,0.4);
        cursor: not-allowed;

        &:hover {
          background: transparent;
        }
      }
    }
  }
</style>
